import React, { useEffect, useRef, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import MolGrid from "../../components/Grid/MolGrid";
import Buttons from "../../components/ui/button/Buttons";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import { CertificateIssuance } from "./data/CertificateIssuanceConfig";
import { CertificateIssuanceConfig } from "./data/CertificateIssuanceConfig";
import { CertificateIssuanceFormData } from "./data/CertificateIssuanceForm.data";
import { CertificateDateModelConfig } from "./data/CertificateDateModelConfig";
const dataSource = [
  {
    companyName: "ABC Tech Pte Ltd",
    certNumber: "SGBP009",
    muaStatus: "Confirmed",
    totalAmount: "INV234234",
    paymentStatus: "Paid",
    status: "Finalisation",
    action: "Issue",
  },
  {
    companyName: "XYZ Ltd",
    certNumber: "SGBP010",
    muaStatus: "Not Confirmed",
    totalAmount: "INV234235",
    paymentStatus: "paid",
    status: "Pending MUA / Invoice",
    action: "Issue",
  },
];
const CertificateIssuanceNew = () => {
  const constCertificateIssuanceRef = useRef();
  const molGridRef = useRef();

  const [showIssueModal, setShowIssueModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  // for centar Modal
  const handleIssueClick = (data) => {
    setShowIssueModal(true);
    setSelectedRow(data);
  };

  const closeIssueModal = () => {
    setShowIssueModal(false);
    setSelectedRow(null);
  };
 const actionHandler = {
    ISSUE: handleIssueClick,
  };
  
  return (
    <>
      {/* {showPageLoader && (
        <div className="processing-modal-overlay">
          <div className="processing-modal">
            <div className="spinner"></div>
            <p>{loaderText}</p>
          </div>
        </div>
      )} */}

      <div className="certificate-issuance">
        <div className="payment-update-filter row">
          <div className="status-input col-10">
            <FormCreator
              ref={constCertificateIssuanceRef}
              {...CertificateIssuanceFormData}
            />
          </div>
          <div className="col-2 xero-right-side-btn mt-2 ">
            <div className="d-flex flex-column gap-2">
              <Buttons
                buttonText="Search"
                buttonTypeClassName="success-btn "
                // onClick={handleSearch}
              />
            </div>
          </div>
        </div>
        <div className="payment-update-list">
          <MolGrid
            ref={molGridRef}
            configuration={CertificateIssuanceConfig}
            // allowPagination={true}
            dataSource={dataSource}
            // isLoading={isLoading}
            // pagination={paginationRequest}
            // onPageChange={handlePageChange}
            onActionChange={actionHandler}
          />
        </div>
        <CenterModel
          show={showIssueModal}
          handleClose={closeIssueModal}
          modelTitle="Issue "
          modelWidth="w-45"
        >
          <div className="d-flex justify-content-center gap-4">
            {" "}
            <FormCreator {...CertificateDateModelConfig} />
          </div>

          <div className="d-flex justify-content-center mt-4">
            <Buttons
              buttonText="Submit"
              buttonTypeClassName="success-btn"
              onClick={() => {
                console.log("Issue API call here", selectedRow);
                closeIssueModal();
              }}
            />
          </div>
        </CenterModel>
      </div>
    </>
  );
};
export default CertificateIssuanceNew;
